import React from 'react';
import EstudianteCursoTab from '../EstudiantesCursos/EstudianteCursoTab';

export default function AsignarCursosEstudiantesModal({ open, idEstudiante, studentName, onClose }) {
    if (!open) return null;

    return (
        <div
            className="roles-confirm-overlay"
            role="dialog"
            aria-modal="true"
            style={{
                position: 'fixed',
                inset: 0,
                background: 'rgba(15,23,42,.45)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 16,
                zIndex: 1000,
            }}
            onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
        >
            <div
                className="roles-confirm-card"
                style={{
                    width: 'min(900px, 96vw)',
                    height: 'min(800px, 90vh)',
                    background: '#fff',
                    borderRadius: 12,
                    boxShadow: '0 10px 30px rgba(0,0,0,.25)',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    padding: '20px'
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
                    <h2 className="roles-title" style={{ margin: 0 }}>Cursos para: <span style={{ color: 'var(--primary-color, #1e293b)' }}>{studentName}</span></h2>
                    <button
                        onClick={onClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '1.5rem',
                            cursor: 'pointer',
                            color: '#64748b'
                        }}
                    >
                        ✕
                    </button>
                </div>

                <div style={{ flex: 1, overflowY: 'auto' }}>
                    <EstudianteCursoTab idEstudiante={idEstudiante} onClose={onClose} />
                </div>
            </div>
        </div>
    );
}
